import React, { useEffect, useState } from 'react';

import { useUnit } from 'hooks/units/index';
import { UNIT_STATUS } from 'constants/constants';

import ButtonCompleted from './ButtonCompleted';
import ButtonComplete from './ButtonComplete';
import unitCourseApi from '../../../../../../api/unitCourseApi';

const CheckboxComplete = (props) => {
  const unitSelected = useUnit();
  const [timer, setTimer] = useState();

  async function trackUserCourseUnit() {
    const result = await unitCourseApi.trackUserCourseTest(unitSelected._id, 5);
  }

  useEffect(() => {
    let interval = setInterval(trackUserCourseUnit, 5000);
    setTimer(interval);
    return () => {
      for (var i = 0; i < 1000; i++) {
        window.clearInterval(i);
      }
    };
  }, []);

  if (unitSelected.status === UNIT_STATUS.COMPLETED) {
    return (
      <div className="text-center my-05">
        <ButtonCompleted setIntervalId={timer} />
      </div>
    );
  }

  return (
    <div className="text-center my-05">
      <ButtonComplete />
    </div>
  );
};

export default CheckboxComplete;
